module.exports = __webpack_public_path__ + "prod/1.42.2/img/icon-headphone.78092ff2.svg";